import { debounce, throttle } from './functions';

export const createCustomEvent = (originalEvent, customEventName, delay, handler = debounce) => {
    window.addEventListener(
        originalEvent,
        handler(() => {
            window.dispatchEvent(new CustomEvent(customEventName));
        }, delay)
    );
};

export const initResizeEnd = (delay = 250) => {
    createCustomEvent('resize', 'resizeEnd', delay);
};

export const initScrollEvents = () => {
    let isScrolling = false;
    let scrollTimeout;

    const handleScroll = () => {
        if (!isScrolling) {
            isScrolling = true;
            window.dispatchEvent(new CustomEvent('scrollStart'));
        }
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
            isScrolling = false;
            window.dispatchEvent(new CustomEvent('scrollEnd'));
        }, 250);
    };

    window.addEventListener('scroll', handleScroll);
};

export const initResizeStart = (limit = 250) => {
    createCustomEvent('resize', 'resizeStart', limit, throttle);
};

export const initCustomEvents = ({ resizeDelay, resizeStartLimit } = {}) => {
    if (resizeDelay !== undefined) initResizeEnd(resizeDelay);
    if (resizeStartLimit !== undefined) initResizeStart(resizeStartLimit);
};

export default {
    initResizeEnd,
    initResizeStart,
    initScrollEvents,
};
